/* eslint-disable no-dupe-else-if */
/* eslint-disable no-constant-condition */
import { FC } from "react";
import { ILogin } from "../../types/auth.types";
import Login from "./login";
import "./login.css";
import {
  LoginContainer,
  LoginHeader,
  LoginWrapper,
  LogoImage
} from './login.style';

const LoginPresentation: FC<ILogin> = ({
  email,
  password,
  onChangeEmail,
  onChangePassword,
  onLogin,
  handleClickShowPassword,
  showPassword,
  isError,
  error
}) => {
  const ScreenDisplay = () => {
      return (
        <Login
          email={email}
          password={password}
          onChangeEmail={onChangeEmail}
          onChangePassword={onChangePassword}
          onLogin={onLogin}
          handleClickShowPassword={handleClickShowPassword}
          showPassword={showPassword}
          isError={isError}
          error={error}
        />
      )
  }

  return (
    <>
      <LoginContainer className="login_container">
        <LoginWrapper>
          <LoginHeader>
            <LogoImage
              src={require('../../../../assets/image/gradegy-big-icon.png')}
              alt="logo"
            />
          </LoginHeader>
          {ScreenDisplay()}
        </LoginWrapper>
      </LoginContainer>
    </>
  )
}

export default LoginPresentation
